import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

const initialState = {
  fieldOfficers: [],
  currentPage: 1,
  totalPages: 1,
  searchKeyword: '',
  status: 'idle', 
  error: null,
};

// fetch field officers
export const fetchFieldOfficer = createAsyncThunk(
  'fieldOfficer/fetch',
  async ({ page, limit, keyword, role }, { rejectWithValue }) => {
    try {
      if (role === 'PARTNER' || role === 'TEAM_MEMBER') {
        const { data } = await axiosInstance.get('/admin/field-officers');
        return {
          fieldOfficers: data, 
          totalCount: data.length
        };
      } else {
        let query = `?page=${page}&limit=${limit}`;
        if (keyword) query += `&keyword=${keyword}`;
        const { data } = await axiosInstance.get(`/super-admin/field-officers${query}`);
        return data;
      }
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.msg || 'Failed to fetch field officers'
      );
    }
  }
);

const fieldOfficerSlice = createSlice({
  name: 'fieldOfficer',
  initialState,
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setSearchKeyword(state, action) {
      state.searchKeyword = action.payload;
      state.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFieldOfficer.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchFieldOfficer.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.fieldOfficers = action.payload.fieldOfficers || [];
        state.totalPages = Math.ceil(
          (action.payload.totalCount || 0) / 15
        );
      })
      .addCase(fetchFieldOfficer.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'An error occurred';
      });
  },
});

export const { setCurrentPage, setSearchKeyword } = fieldOfficerSlice.actions;
export default fieldOfficerSlice.reducer;
